<template>
  <div class="min-h-screen">
    <Header />
    
    <!-- Hero Section -->
    <section class="page-hero-shell pt-32 pb-20">
      <div class="absolute inset-0 page-overlay-layer space-pattern opacity-40"></div>
      <div class="hero-orb page-overlay-layer hero-orb-b"></div>
      <div class="hero-orb page-overlay-layer hero-orb-c"></div>
      
      <div class="page-content-layer max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
          <div class="hero-badge mb-6">
            <span>MAGIC 团队</span>
          </div>
          <h1 class="text-5xl md:text-7xl font-bold mb-6">
            <span class="gradient-text">关于我们</span>
          </h1>
          <p class="text-xl text-gray-700 dark:text-dark-muted max-w-3xl mx-auto">
            专注于数字营销技术创新，为企业提供全方位的数字化解决方案
          </p>
        </div>
      </div>
    </section>

    <!-- Company Story -->
    <section class="py-20">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 class="section-title gradient-text mb-8">我们的故事</h2>
            <p class="text-lg text-gray-700 dark:text-dark-muted mb-6">
              MAGIC成立于2023年，是一家专注于数字营销技术的创新型企业。我们致力于通过AI和大数据技术，为全球企业提供领先的数字营销解决方案。
            </p>
            <p class="text-lg text-gray-700 dark:text-dark-muted mb-6">
              多年来，我们服务了超过500家企业客户，覆盖电商、游戏、金融、教育等多个行业。我们的产品包括SSP媒体管理平台、DSP广告管理平台、SDK移动广告等，构建了完整的数字营销生态体系。
            </p>
            <p class="text-lg text-gray-700 dark:text-dark-muted">
              展望未来，我们将继续投入研发，不断创新，为客户提供更优质的产品和服务。
            </p>
          </div>
          
          <div class="grid grid-cols-2 gap-6">
            <div class="glass-card p-6 card-hover visual-surface">
              <div class="text-4xl font-bold gradient-text mb-2">2023</div>
              <div class="text-sm text-gray-700 dark:text-dark-muted">公司成立</div>
            </div>
            <div class="glass-card p-6 card-hover visual-surface">
              <div class="text-4xl font-bold gradient-text mb-2">500+</div>
              <div class="text-sm text-gray-700 dark:text-dark-muted">企业客户</div>
            </div>
            <div class="glass-card p-6 card-hover visual-surface">
              <div class="text-4xl font-bold gradient-text mb-2">50+</div>
              <div class="text-sm text-gray-700 dark:text-dark-muted">团队成员</div>
            </div>
            <div class="glass-card p-6 card-hover visual-surface">
              <div class="text-4xl font-bold gradient-text mb-2">6大</div>
              <div class="text-sm text-gray-700 dark:text-dark-muted">核心产品</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Mission & Vision -->
    <section class="py-20 relative">
      <div class="absolute inset-0 page-overlay-layer bg-gradient-to-r from-cosmic/5 via-nebula/5 to-stellar/5"></div>

      <div class="page-content-layer max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid md:grid-cols-3 gap-8">
          <div class="card card-hover visual-surface">
            <div class="w-16 h-16 mx-auto mb-6 icon-shell">
              <FeatureIcon name="targeting" size="xl" variant="minimal" />
            </div>
            <h3 class="text-2xl font-bold mb-4 text-dark-text text-center">使命</h3>
            <p class="text-gray-700 dark:text-dark-muted text-center">
              通过技术创新，让数字营销更简单、更高效，助力企业实现数字化增长
            </p>
          </div>

          <div class="card card-hover visual-surface">
            <div class="w-16 h-16 mx-auto mb-6 icon-shell">
              <FeatureIcon name="vision" size="xl" variant="minimal" />
            </div>
            <h3 class="text-2xl font-bold mb-4 text-dark-text text-center">愿景</h3>
            <p class="text-gray-700 dark:text-dark-muted text-center">
              成为全球领先的数字营销技术提供商，推动行业数字化转型
            </p>
          </div>

          <div class="card card-hover visual-surface">
            <div class="w-16 h-16 mx-auto mb-6 icon-shell">
              <FeatureIcon name="gem" size="xl" variant="minimal" />
            </div>
            <h3 class="text-2xl font-bold mb-4 text-dark-text text-center">价值观</h3>
            <p class="text-gray-700 dark:text-dark-muted text-center">
              创新、专业、诚信、合作，以客户为中心，追求卓越
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Team -->
    <!-- <section class="py-20">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="section-title gradient-text mb-16">核心团队</h2>

        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div v-for="(member, index) in team" :key="index"
               class="card card-hover text-center">
            <div class="w-24 h-24 rounded-full bg-gradient-to-br from-cosmic to-nebula mx-auto mb-4 flex items-center justify-center">
              <span class="text-3xl">{{ member.avatar }}</span>
            </div>
            <h3 class="text-xl font-bold mb-2 text-dark-text">{{ member.name }}</h3>
            <p class="text-cosmic-adaptive mb-4">{{ member.title }}</p>
            <p class="text-gray-700 dark:text-dark-muted text-sm">{{ member.bio }}</p>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Culture -->
    <section class="py-20 relative">
      <div class="absolute inset-0 page-overlay-layer bg-gradient-to-r from-cosmic/5 via-nebula/5 to-stellar/5"></div>
      
      <div class="page-content-layer max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="section-title gradient-text mb-16">企业文化</h2>
        
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div v-for="(value, index) in culture" :key="index"
               class="glass-card-enhanced p-8 text-center visual-surface">
            <div class="w-14 h-14 mx-auto mb-4 icon-shell">
              <FeatureIcon :name="value.iconName || 'rocket'" size="lg" variant="minimal" />
            </div>
            <h3 class="text-xl font-bold mb-3 text-dark-text">{{ value.title }}</h3>
            <p class="text-gray-700 dark:text-dark-muted text-sm">{{ value.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="py-32">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="section-title gradient-text mb-12 text-center">联系我们</h2>
        
        <div class="grid lg:grid-cols-2 gap-8 items-center">
          <!-- 左侧：地图 -->
          <div class="relative w-full h-96 rounded-lg overflow-hidden">
            <img src="/map.jpg" alt="公司地址地图" class="w-full h-full object-cover">
          </div>
          
          <!-- 右侧：联系信息 -->
          <div class="space-y-4">
            <div class="glass-card p-4 flex items-center card-hover visual-surface">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg icon-shell mr-4">
                <FeatureIcon name="users" size="md" variant="minimal" />
              </div>
              <div>
                <h3 class="text-base font-semibold text-dark-text mb-1">联系人</h3>
                <p class="text-gray-700 dark:text-dark-muted text-sm">张仕达</p>
              </div>
            </div>

            <div class="glass-card p-4 flex items-center card-hover visual-surface">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg icon-shell mr-4">
                <FeatureIcon name="mobile" size="md" variant="minimal" />
              </div>
              <div>
                <h3 class="text-base font-semibold text-dark-text mb-1">手机号</h3>
                <a href="tel:13501682978" class="text-primary text-base hover:text-primary-700 transition-colors">
                  13501682978
                </a>
                <p class="text-gray-700 dark:text-dark-muted text-xs">7x24小时服务</p>
              </div>
            </div>
            
            <div class="glass-card p-4 flex items-center card-hover visual-surface">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg icon-shell mr-4">
                <FeatureIcon name="email" size="md" variant="minimal" />
              </div>
              <div>
                <h3 class="text-base font-semibold text-dark-text mb-1">邮箱</h3>
                <a href="mailto:zhangsd@magicacid.cn" class="text-primary text-base hover:text-primary-700 transition-colors">
                  zhangsd@magicacid.cn
                </a>
                <p class="text-gray-700 dark:text-dark-muted text-xs">24小时内回复</p>
              </div>
            </div>

            <div class="glass-card p-4 flex items-center card-hover visual-surface">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg icon-shell mr-4">
                <FeatureIcon name="location" size="md" variant="minimal" />
              </div>
              <div>
                <h3 class="text-base font-semibold text-dark-text mb-1">公司地址</h3>
                <p class="text-gray-700 dark:text-dark-muted text-sm">上海市徐汇区田林路388号1号楼11楼1111室</p>
                <p class="text-gray-700 dark:text-dark-muted text-xs">欢迎来访</p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="mt-12 text-center">
          <button @click="sendEmail" class="btn-primary text-lg">
            发送咨询邮件
          </button>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
// const team = [
//   {
//     name: '张明',
//     title: 'CEO & 创始人',
//     avatar: '👨‍💼',
//     bio: '15年数字营销行业经验，前阿里巴巴高级产品经理'
//   },
//   {
//     name: '李华',
//     title: 'CTO',
//     avatar: '👩‍💻',
//     bio: '10年技术团队管理经验，前百度技术总监'
//   },
//   {
//     name: '王强',
//     title: 'COO',
//     avatar: '👨‍💼',
//     bio: '12年运营管理经验，前腾讯运营总监'
//   },
//   {
//     name: '赵敏',
//     title: 'CMO',
//     avatar: '👩‍💼',
//     bio: '10年市场营销经验，前字节跳动市场总监'
//   }
// ]

const culture = [
  {
    icon: '🚀',
    iconName: 'lightbulb',
    title: '创新驱动',
    description: '鼓励创新思维，拥抱变化，持续学习'
  },
  {
    icon: '🤝',
    iconName: 'users',
    title: '团队合作',
    description: '协作共赢，相互支持，共同成长'
  },
  {
    icon: '🎯',
    iconName: 'targeting',
    title: '结果导向',
    description: '专注目标，追求卓越，创造价值'
  },
  {
    icon: '💡',
    iconName: 'lightbulb',
    title: '客户至上',
    description: '以客户为中心，提供优质服务'
  }
]

const sendEmail = () => {
  const subject = encodeURIComponent('咨询magic服务')
  const body = encodeURIComponent('您好，\n\n我对贵公司的服务很感兴趣，希望了解更多信息。\n\n期待您的回复！')
  window.location.href = `mailto:zhangsd@magicacid.cn?subject=${subject}&body=${body}`
}
</script>
